module.exports = __webpack_public_path__ + "img/wizard-01@2x.06e232d2.png";